"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _systemSetting = require("@/api/systemSetting");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "pop-set-certificate",
  components: {
    Tinymce: _index.default
  },
  props: {},
  data: function data() {
    return {
      isShow: false,
      resolve: null,
      reject: null,
      formData: {
        id: "",
        niceConsumeFee: "",
        consumeFeeContent: ""
      },
      rules: {
        niceConsumeFee: [{
          required: true,
          message: "请输入请输入用户累计消费达标金额",
          trigger: "blur"
        }],
        consumeFeeContent: [{
          required: true,
          message: "请输入累计消费的富文本",
          trigger: ["blur", "change"]
        }]
      }
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.resolve = null;
    this.reject = null;
  },
  watch: {},
  methods: {
    clearForm: function clearForm() {
      this.formData.niceConsumeFee = "";
      this.formData.consumeFeeContent = "";
    },
    // 打开弹窗
    openPop: function openPop(data) {
      var _this = this;
      this.isShow = true;
      this.clearForm();
      this.getCertificateSet();
      return new Promise(function (re, rj) {
        _this.resolve = re;
        _this.reject = rj;
      });
    },
    // 获取证书设置信息
    getCertificateSet: function getCertificateSet() {
      var _this2 = this;
      (0, _systemSetting.getMemberCardApi)().then(function (res) {
        if (res) {
          _this2.formData.id = res.id;
          _this2.formData.niceConsumeFee = res.niceConsumeFee;
          _this2.formData.consumeFeeContent = res.consumeFeeContent;
        }
      });
    },
    // 关闭弹窗
    closePop: function closePop() {
      this.isShow = false;
      this.resolve([false, null]);
    },
    // 保存
    onSubmit: function onSubmit() {
      var _this3 = this;
      this.$refs['证书设置表单'].validate(function (valid) {
        if (!valid) return;
        (0, _systemSetting.saveMemberCardApi)(_this3.formData).then(function (res) {
          _this3.$message.success("操作成功");
          _this3.isShow = false;
          _this3.resolve([true, _this3.description]);
        });
      });
    }
  }
};